export default __webpack_public_path__ + "static/media/image-ph-health-home-w.3fa57437.webp";